var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"fields":_vm.table_fields,"items":_vm.table_items}})}
var staticRenderFns = []

export { render, staticRenderFns }